module.exports = __webpack_public_path__ + "static/media/icon-dashboard-link.bc0053d9.svg";